import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  domains: insights.map((insight) => `reddit.com/${insight.name}`)
})

const generateRedditDomainsNameStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateRedditDomainsNameStrategy
